import { getWarningBannerTemplate } from "../../shortcodes/templates";
import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";

const warningBannerConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Warning Banner",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "labelText",
          label: "Label text",
          placeholder: "WARNING:",
        },
        {
          type: "textarea",
          name: "contentText",
          label: "Content text",
          placeholder: "Enrollment closes on Tuesday 02/24/2026 at midnight.",
          maximized: true,
        },
        {
          type: "colorinput",
          name: "labelBgColor",
          label: "Label background color",
        },
        {
          type: "colorinput",
          name: "contentBgColor",
          label: "Content background color",
        },
        {
          type: "colorinput",
          name: "textColor",
          label: "Text color",
        },
      ],
    },
    initialData: {
      labelText: "WARNING:",
      contentText: 'Enrollment closes on {{ shortcodes.date("eeee", "0") }}, {{ shortcodes.date("MM/dd/yyyy", "0") }} at midnight.',
      labelBgColor: "#C41230",
      contentBgColor: "#002855",
      textColor: "#FFFFFF",
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getWarningBannerTemplate({
        labelText: data.labelText,
        contentText: data.contentText,
        labelBgColor: data.labelBgColor,
        contentBgColor: data.contentBgColor,
        textColor: data.textColor,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api, false);
      api.close();
    },
  });
};

export { warningBannerConfig };
